export default function UploadFileIcon({ color = "#7F869B", size = 14 }: { color?: string; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.68998 14.0096C4.44612 14.0096 3.25321 13.537 2.37366 12.6957C1.49412 11.8544 1 10.7133 1 9.52353C1 8.33375 1.49412 7.1927 2.37366 6.3514C3.25321 5.5101 4.44612 5.03746 5.68998 5.03746C5.98375 3.7287 6.84316 2.57858 8.07915 1.84011C8.69114 1.47445 9.37717 1.22086 10.0981 1.09382C10.819 0.966781 11.5606 0.968775 12.2806 1.09969C13.0007 1.23061 13.685 1.48788 14.2945 1.85682C14.9041 2.22576 15.427 2.69914 15.8332 3.24994C16.2395 3.80074 16.5213 4.41816 16.6624 5.06697C16.8036 5.71577 16.8014 6.38324 16.6559 7.03127H17.6528C18.5782 7.03127 19.4657 7.39888 20.12 8.05322C20.7744 8.70757 21.142 9.59505 21.142 10.5204C21.142 11.4458 20.7744 12.3333 20.12 12.9876C19.4657 13.642 18.5782 14.0096 17.6528 14.0096H16.6559"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.68018 11.0188L10.6709 8.02808L13.6616 11.0188"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10.6689 8.02808V17.0002" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
